import {
  type TutorialObjective,
  TutorialMessageColors
} from '@powerplay/core-minigames'
import { defineStore } from 'pinia'

export interface TutorialState {
  anne: {
    showAnne: boolean,
    isRight: boolean
  },
  mobile: boolean,
  tutorialMessage: {
    message: string,
    showMessage: boolean,
    color: TutorialMessageColors,
    yellowText: string,
    yellowTextSpecial: boolean,
    offset: boolean
  },
  objectives: TutorialObjective[],
  settings: boolean,
  buttons: {
    showButtonStart: boolean,
    showMovementButtons: boolean,
  }
  showImpulseBar: boolean,
  showBarStart: boolean,
  showBarSpeed: boolean,
  showArrowAim: boolean
}

const initialState = (): TutorialState => ({
  anne: {
    showAnne: false,
    isRight: false
  },
  mobile: false,
  tutorialMessage: {
    message: '',
    showMessage: false,
    color: TutorialMessageColors.blank,
    yellowText: '',
    yellowTextSpecial: false,
    offset: false
  },
  settings: false,
  objectives: [],
  buttons: {
    showMovementButtons: false,
    showButtonStart: false
  },

  showImpulseBar: false,
  showBarStart: false,
  showBarSpeed: false,
  showArrowAim: false
})

export const tutorialState = defineStore('tutorialState', {
  state: initialState,
})
